import React from 'react'

const SingleSiteName = () => {
  return (
    <>
    
    </>
  )
}

export default SingleSiteName